import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import locale from "@amcharts/amcharts4/lang/pt_BR.js";

function montarGraficoClusteredColumnMensal({
    state,
    component,
    nome,
    dados = [],
    seriesLinhas = [],
    configSeriesLinhas = [{ sufixoSerie: "", descricao: "Projeção", campo: "valor" }],
    titulo,
    prefixo,
    sufixo,
    exportar = true,
    fontColor,
    labelPersonalizado = false,
}) {
    if (component) {
        component.dispose();
    }

    let chart = am4core.create(nome, am4charts.XYChart3D);
    chart.colors.step = 1;

    chart.colors.list = state.cores || [];

    chart.language.locale = locale;

    let title = chart.titles.create();
    title.text = titulo;
    title.fontSize = 16;
    title.marginBottom = 30;

    if (exportar) {
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "Gráfico";
        chart.exporting.menu.align = "right";
        chart.exporting.menu.verticalAlign = "top";
        chart.exporting.menu.items = [
            {
                label: "...",
                menu: [
                    {
                        type: "png",
                        label: "PNG",
                    },
                ],
            },
        ];
    }

    chart.legend = new am4charts.Legend();
    chart.legend.position = "top";
    chart.legend.paddingBottom = 20;
    chart.legend.labels.template.maxWidth = 95;

    if (state.mobile) {
        chart.legend.labels.template.fontSize = 10;
    }
    chart.language.locale["_decimalSeparator"] = ",";
    chart.language.locale["_thousandSeparator"] = ".";
    chart.numberFormatter.numberFormat = "###,###,###,###.00";

    let xAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    xAxis.dataFields.category = "category";
    xAxis.renderer.cellStartLocation = 0.1;
    xAxis.renderer.cellEndLocation = 0.9;
    xAxis.renderer.grid.template.location = 0;
    xAxis.paddingBottom = 15;

    let yAxis = chart.yAxes.push(new am4charts.ValueAxis());
    yAxis.min = 0;

    let arrangeColumns = () => {
        let series = chart.series.getIndex(0);

        let w = 1 - xAxis.renderer.cellStartLocation - (1 - xAxis.renderer.cellEndLocation);
        if (series.dataItems.length > 1) {
            let x0 = xAxis.getX(series.dataItems.getIndex(0), "categoryX");
            let x1 = xAxis.getX(series.dataItems.getIndex(1), "categoryX");
            let delta = ((x1 - x0) / chart.series.length) * w;
            if (am4core.isNumber(delta)) {
                let middle = chart.series.length / 2;

                let newIndex = 0;
                chart.series.each(function (series) {
                    if (!series.isHidden && !series.isHiding) {
                        series.dummyData = newIndex;
                        newIndex++;
                    } else {
                        series.dummyData = chart.series.indexOf(series);
                    }
                });
                let visibleCount = newIndex;
                let newMiddle = visibleCount / 2;

                chart.series.each(function (series) {
                    let trueIndex = chart.series.indexOf(series);
                    let newIndex = series.dummyData;

                    let dx = (newIndex - trueIndex + middle - newMiddle) * delta;

                    series.animate({ property: "dx", to: dx }, series.interpolationDuration, series.interpolationEasing);
                    series.bulletsContainer.animate({ property: "dx", to: dx }, series.interpolationDuration, series.interpolationEasing);
                });
            }
        }
    };

    let createLineSeries = (value, name, color, options = {}) => {
        let lineSeries = chart.series.push(new am4charts.LineSeries());

        lineSeries.dataFields.valueY = value;
        lineSeries.dataFields.categoryX = "category";
        lineSeries.name = name;
        lineSeries.strokeWidth = options.strokeWidth || 3;
        lineSeries.stroke = am4core.color(color);
        lineSeries.fill = am4core.color(color);
        lineSeries.strokeDasharray = options.strokeDasharray || "";
        lineSeries.segments.template.strokeDasharray = options.strokeDasharray || "";
        lineSeries.fillOpacity = options.fillOpacity || 0;
        lineSeries.hiddenInLegend = !!options.hiddenInLegend;

        if (options.openValueField) {
            lineSeries.dataFields.openValueY = options.openValueField;
        }

        let bullet = lineSeries.bullets.push(new am4charts.CircleBullet());
        bullet.circle.radius = 2;
        bullet.circle.fill = am4core.color(color);
        bullet.circle.stroke = am4core.color("#ffffff");
        bullet.circle.strokeWidth = 2;
        bullet.disabled = !!options.hideBullet;

        bullet.tooltipText = `{categoryX}: [bold]${name} - ${prefixo} {valueY.formatNumber("###,###,###,###.00")} ${sufixo}[/]`;

        if (options.hideTooltip) {
            bullet.tooltipText = "";
            lineSeries.tooltip.disabled = true;
        }

        return lineSeries;
    };

    let createSeries = (value, name) => {
        let series = chart.series.push(new am4charts.ColumnSeries3D());
        series.dataFields.valueY = value;
        series.dataFields.categoryX = "category";
        series.dataFields[name + "-tooltip"] = name + "-tooltip";
        series.name = name;

        series.events.on("hidden", arrangeColumns);
        series.events.on("shown", arrangeColumns);

        // let bullet = series.bullets.push(new am4charts.LabelBullet());
        // bullet.interactionsEnabled = false;
        // bullet.dy = 30;
        // bullet.label.text = '{valueY}';
        // bullet.label.fill = am4core.color('#ffffff');
        // bullet.label.truncate = false;
        // bullet.label.hideOversized = true;

        series.columns.template.tooltipText = labelPersonalizado
            ? `{${name + "-tooltip"}}`
            : `{categoryX}: [bold]${prefixo} {valueY.formatNumber("###,###,###,###.00")} ${sufixo}[/]`;
        series.columns.template.fillOpacity = 0.8;

        return series;
    };

    //lista de anos (nomes das propriedades)
    let series = [];
    dados.forEach((item) => {
        item.anos.forEach((itemAno) => {
            if (!series.includes(itemAno.ano)) {
                series.push(itemAno.ano);
            }
        });
    });
    series.sort();

    let seriesPorMes = [];

    for (let i = 0; i < 12; i++) {
        let date = new Date(2024, i, 10); //ano e dia fixo porque não importa, só importa o mês
        let nomeMes = date.toLocaleString("pt-BR", { month: "long" });
        let nomeMesInicialMaiuscula = nomeMes.charAt(0).toUpperCase() + nomeMes.slice(1);
        let elemento = { category: nomeMesInicialMaiuscula };

        //adiciona a lista de propriedades inicialmente com valores zerados, para cada mes
        series.forEach((nomePropriedade) => {
            elemento[nomePropriedade] = 0;
        });
        seriesPorMes.push(elemento);
    }
    chart.data = seriesPorMes;

    //cria 12 objetos, um para cada mês, e dentro de cada um os anos com seus respectivos valores
    for (let i = 0; i < 12; i++) {
        const mes = dados.find((item) => parseInt(item.mes) == i + 1);

        //procura um objeto com os valores do referido mes em cada um dos anos
        if (mes) {
            chart.data = chart.data.map((item, j) => {
                //identifica o elemento do mesmo mês que estava na lista original com os dados zerados
                if (i == j) {
                    const valoresSeries = {};

                    series.forEach((nomeSerie) => {
                        //EX: {"ano": "2022",	"mes": "01", "valor": 941}
                        const itemMesAno = (mes.anos || []).find((item) => item && item.ano == nomeSerie) || {};
                        valoresSeries[nomeSerie] = itemMesAno.valor || 0;
                        valoresSeries[nomeSerie + "-tooltip"] = itemMesAno.tooltip;
                    });

                    return {
                        ...item,
                        ...valoresSeries,
                    };
                } else {
                    return item;
                }
            });
        }
    }

    series.forEach((item) => {
        createSeries(String(item), String(item));
    });

    const coresProjecao = [
        "#C77DFF", // lilás
        "#FF70A6", // rosa
        "#70D6FF", // azul claro
        "#B388EB", // roxo claro
        "#FF99C8", // rosa claro
    ];

    seriesLinhas.forEach((projecao, index) => {
        const nomeSerie = String(projecao.ano);

        chart.data = chart.data.map((item, indexMes) => {
            const itemMes = projecao.meses.find((x) => Number(x.mes) === indexMes + 1);
            const valoresSeriesLinha = {};

            (configSeriesLinhas || []).forEach((configSerie) => {
                const sufixoSerie = configSerie.sufixoSerie ? `-${configSerie.sufixoSerie}` : "";
                valoresSeriesLinha[`${nomeSerie}${sufixoSerie}`] = itemMes ? itemMes[configSerie.campo] : null;
            });

            return {
                ...item,
                ...valoresSeriesLinha,
            };
        });

        const corProjecao = coresProjecao[index % coresProjecao.length];
        (configSeriesLinhas || []).forEach((configSerie) => {
            const sufixoSerie = configSerie.sufixoSerie ? `-${configSerie.sufixoSerie}` : "";
            const nomeCampoSerie = `${nomeSerie}${sufixoSerie}`;
            const configSerieOpenValue = (configSeriesLinhas || []).find((item) => item.campo === configSerie.openValueField);
            const nomeCampoOpenValue = configSerieOpenValue
                ? `${nomeSerie}${configSerieOpenValue.sufixoSerie ? `-${configSerieOpenValue.sufixoSerie}` : ""}`
                : null;
            const corSerie = configSerie.color || corProjecao;

            createLineSeries(nomeCampoSerie, `${configSerie.descricao} ${nomeSerie}`, corSerie, {
                openValueField: nomeCampoOpenValue,
                fillOpacity: configSerie.fillOpacity,
                strokeWidth: configSerie.strokeWidth,
                hiddenInLegend: configSerie.hiddenInLegend,
                hideBullet: configSerie.hideBullet,
                hideTooltip: configSerie.hideTooltip,
                strokeDasharray: configSerie.strokeDasharray,
            });
        });
    });

    if (fontColor) {
        const cor = am4core.color(fontColor);

        // Cor da legenda
        chart.legend.labels.template.fill = cor;

        // Cor do título
        title.fill = cor;

        // Cor dos labels do eixo X
        xAxis.renderer.labels.template.fill = cor;

        // Cor do título do eixo X (caso use)
        xAxis.title && (xAxis.title.fill = cor);

        // Cor dos labels do eixo Y
        yAxis.renderer.labels.template.fill = cor;

        // Cor do título do eixo Y (caso use)
        yAxis.title && (yAxis.title.fill = cor);

        // Cor dos valores dos tooltips (caso deseje alterar isso também)
        chart.tooltip.getFillFromObject = false;
        chart.tooltip.label.fill = cor;
    }

    return chart;
}

export { montarGraficoClusteredColumnMensal };
